export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,ms:4,block:{md:4,lg:4,xl:4,ms:4}}}